// sentry
import {sentryInit} from '../core/utils/sentry'

// non-react, but required to embed
import '../../js/front'

// react app starts below
import React from 'react'
import {render} from 'react-dom'
import App from './app'

sentryInit()

// https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Browser_Compatibility
if (window.NodeList && !window.NodeList.prototype.forEach) {
  window.NodeList.prototype.forEach = Array.prototype.forEach
}

render(
  <App />, document.getElementById('react-root')
)
